export const faceEvalResult = {
  liveWeight: 0,
  weights: null,
}
